import { useBalance } from '@/queries/useBalance';
import { formatCurrency } from '@/lib/currency';

export function IncomeChartTooltipContent() {
    const { balance } = useBalance();
    const totalStripeRevenue = balance?.total_stripe_revenue?.amount ?? 0;
    const stripeCurrency = balance?.total_stripe_revenue?.currency ?? 'USD';
    const totalReferralRevenue = balance?.total_referral_revenue?.amount ?? 0;
    const referralCurrency = balance?.total_referral_revenue?.currency ?? 'USD';
    const totalPaypalRevenue = balance?.total_paypal_revenue?.amount ?? 0;
    const paypalCurrency = balance?.total_paypal_revenue?.currency ?? 'USD';
    const shouldShowSalesVsReferrals = totalStripeRevenue > 0 && totalReferralRevenue > 0;

    if (shouldShowSalesVsReferrals) {
        return (
            <div className='text-caption-2-regular flex flex-col items-start p-3 text-left'>
                <div className='font-bold'>Revenue Breakdown</div>
                <div className='mt-2'>
                    Sales: <span className='font-bold'>{formatCurrency(totalStripeRevenue, stripeCurrency)}</span>
                </div>
                <div className='mb-2'>
                    Referral:{' '}
                    <span className='font-bold'>{formatCurrency(totalReferralRevenue, referralCurrency)}</span>
                </div>
                <hr className='m-0 w-full' />
                <div className='mt-2'>
                    Stripe: <span className='font-bold'>{formatCurrency(totalStripeRevenue, stripeCurrency)}</span>
                </div>
                <div>
                    PayPal: <span className='font-bold'>{formatCurrency(totalPaypalRevenue, paypalCurrency)}</span>
                </div>
                <div className='mt-2'>
                    PayPal earnings will show up in your personal account, and not in Stan’s Account Balance.{' '}
                    <a target='_blank' href='https://help.stan.store/article/53-how-to-connect-stan-with-paypal'>
                        Click here
                    </a>{' '}
                    to learn more.
                </div>
            </div>
        );
    }
    return (
        <div className='text-caption-2-regular flex flex-col items-start p-3 text-left'>
            <div className='font-bold'>Revenue Breakdown</div>
            <div className='mt-2'>
                Stripe: <span className='font-bold'>{formatCurrency(totalStripeRevenue, stripeCurrency)}</span>
            </div>
            <div>
                PayPal: <span className='font-bold'>{formatCurrency(totalPaypalRevenue, paypalCurrency)}</span>
            </div>
            <div className='mt-2'>
                PayPal earnings will show up in your personal account, and not in Stan’s Account Balance.{' '}
                <a target='_blank' href='https://help.stan.store/article/53-how-to-connect-stan-with-paypal'>
                    Click here
                </a>{' '}
                to learn more.
            </div>
        </div>
    );
}
